import { MAX_DATA_ENTRY_STEP } from "src/config";
import { FormikStep } from "src/types";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const STORAGE_KEY_CURRENT_STEP = "CAIcurrentStep";
interface CurrentStepState {
  currentStep: FormikStep;
  setCurrentStep: (step: number) => void;
  goNextStep: () => void;
  goBackStep: () => void;
  resetCurrentStep: () => void;
}
export const useCurrentStepStore = create<CurrentStepState>()(
  persist(
    (set) => ({
      currentStep: FormikStep.VEHICLE_A,
      setCurrentStep: (step) => set({ currentStep: step }),
      goNextStep: () =>
        set((state) => ({
          currentStep:
            state.currentStep < MAX_DATA_ENTRY_STEP
              ? state.currentStep + 1
              : MAX_DATA_ENTRY_STEP,
        })),
      goBackStep: () =>
        set((state) => ({
          currentStep: state.currentStep > 0 ? state.currentStep - 1 : 0,
        })),
      resetCurrentStep: () => set({ currentStep: FormikStep.VEHICLE_A }),
    }),
    {
      // key in localStorage
      name: STORAGE_KEY_CURRENT_STEP,
      // opzionale: specifica esplicitamente lo storage
      storage: createJSONStorage(() => localStorage),
    }
  )
);
